import React, { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import InputError from '../../form/InputError';
import { InputWithSaveBase } from '../../form/InputsWithSave/InputWithSaveBase';
import { RichtextInputStyled } from '../RichtextInput';
import { getError } from '../utils';

type Props = {
  className?: string;
  containerClassName?: string;
  placeholder?: string;
  labelComponent?: ReactNode;
  value: string;
  isInEditModeInitial?: boolean;
  readOnly?: boolean;
  onChange: (value?: string) => void;
};

export const RichtextInputWithSave: React.FC<
  React.PropsWithChildren<Props>
> = ({ containerClassName, labelComponent, value, readOnly, onChange }) => (
  <InputWithSaveBase
    containerClassName={containerClassName}
    value={value}
    labelComponent={labelComponent}
    onChange={(newValue) => onChange(newValue?.toString())}
    readOnly={readOnly}
    renderInput={(inputProps) => (
      <RichtextInputStyled
        readOnly={inputProps.readOnly}
        className={inputProps.className}
        value={inputProps.value?.toString()}
        onChange={(newValue) => inputProps.onChange(newValue)}
      />
    )}
  />
);

type PropsControlled = { name: string } & Omit<Props, 'value' | 'onChange'>;

export const RichtextInputWithSaveControlled: React.FC<
  React.PropsWithChildren<PropsControlled>
> = ({ name, isInEditModeInitial, ...props }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = getError(name, errors);

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <RichtextInputWithSave
            {...props}
            value={field.value ?? ''}
            onChange={field.onChange}
            isInEditModeInitial={isInEditModeInitial || !!error}
            containerClassName={error ? 'is-invalid' : ''}
            className={error ? 'is-invalid' : ''}
          />
        )}
      />
      <InputError error={error} />
    </>
  );
};
